/*
 * @Author: wangzeshi01 2091826206@qq.com
 * @Date: 2024-05-24 15:27:10
 * @LastEditors: wangzeshi01 2091826206@qq.com
 * @LastEditTime: 2024-05-27 23:56:26
 * @FilePath: \nurse-on-site-operation-end\src\api\adminOrder.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from '../lib/request'


export const adminOrderApi = {
  queryList: (data) => {
    return axios.post(`/adminOrder/queryList`, data)
  },
  refund: (data) => {
    return axios.post(`/adminOrder/refund`, data)
  },
  orderOver: (data) => {
    return axios.post(`/adminOrder/orderOver`, data)
  },
  appendServiceRemark: (data) => {
    return axios.post(`/adminOrder/addServiceRemark`, data)
  },
  confirmApplyReselectNurse: (data) => {
    return axios.post(`/adminOrder/confirmApplyReselectNurse`, data)
  },
  placeOrderCustomerCount: (data) => {
    return axios.post(`/adminOrder/placeOrderCustomerCount`, data)
  },
  getMaxOrderId:()=>{
    return axios.post(`/adminOrder/getMaxOrderId`)
  },
  platformInterventionCount: (data) => {
    return axios.post(`/adminOrder/platformInterventionCount`, data)
  },
  platformDealRefundCount: (data) => {
    return axios.post(`/adminOrder/platformDealRefundCount`, data)
  },
  todayNewOrderCount: (data) => {
    return axios.post(`/adminOrder/todayNewOrderCount`, data)
  },
  todaySuccessOrderCount: (data) => {
    return axios.post(`/adminOrder/todaySuccessOrderCount`, data)
  },
  saveWithHistoryAddress: (data) => {
    return axios.post(`/adminOrder/saveWithHistoryAddress`, data)
  },
  getRecentApprovedOrderByOrderItemId: (data) => {
    return axios.post(`/adminOrder/getRecentApprovedOrderByOrderItemId`, data)
  },
  countNearNurseByLocation: (data) => {
    return axios.post(`/adminOrder/countNearNurseByLocation`, data)
  },
  exportInsurance: (data) => {
    return axios.post(`/adminOrder/exportInsurance`, data)
  },
  editOrder: (data) => {
    return axios.post(`/adminOrder/editOrder`, data)
  },
  editOrderPayAt: (data) => {
    return axios.post(`/adminOrder/editOrderPayAt`, data)
  },
  changeOrderStatus: (data) => {
    return axios.post(`/adminOrder/changeOrderStatus`, data)
  },
  exportShiftOrders: (data) => {
    return axios.post(`/adminOrder/exportShiftOrders`, data)
  },
  getTodayShiftOrders: (data) => {
    return axios.post(`/adminOrder/getTodayShiftOrders`, data)
  },
  changeCustomer: (data) => {
    return axios.post(`/adminOrder/changeCustomer`, data)
  },
  queryVirtualPhoneCallHistory: (data) => {
    return axios.post(`/adminOrder/queryVirtualPhoneCallHistory`, data)
  },
  getOrderDetail: (data) => {
    return axios.post(`/adminOrder/getOrderDetail`, data)
  },
  adminSelectNurseForServiceDemandOrder: (data) => {
    return axios.post(`/adminOrder/adminSelectNurseForServiceDemandOrder`, data)
  },
  payZero: (data) => {
    return axios.post(`/adminOrder/payZero`, data)
  },
  getCancelReasonConfig: (data) => {
    return axios.post(`/adminOrder/getCancelReasonConfig`, data)
  },
  updateCancelReason: (data) => {
    return axios.post(`/adminOrder/updateCancelReason`, data)
  },
  setZeroPayOrderRefunded: (data) => {
    return axios.post(`/adminOrder/setZeroPayOrderRefunded`, data)
  },
  clearOrderById: (data) => {
    return axios.post(`/adminOrder/clearOrderById`, data)
  }
}
